import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { authData, authHelper, AuthParams, useAuthDataStore } from '@entities/user';
import { Button } from '@shared/ui/molecules';
import { homeLoginClickGtm } from '@shared/lib/gtm/redesign';
const LoginButton: FC = () => {
  const {
    isAuth
  } = useAuthDataStore();
  const handleLoginClick = () => {
    homeLoginClickGtm();
    if (!isAuth) {
      authHelper.onSignIn();
      authHelper.mtsIdAuthorize(authData() as AuthParams).then(mtsId => {
        authHelper.redirectTo(mtsId);
      });
    }
  };
  return <ButtonWrapper>
      <Button size={{
      desktop: '44',
      mobile: '32'
    }} onClick={handleLoginClick}>
        Войти
      </Button>
    </ButtonWrapper>;
};
export default LoginButton;
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "b743bz1",
  propsAsIs: false
});

require("./LoginButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./LoginButton.tsx");